// External File: https://api.html5media.info/1.1.6/html5media.min.js

// Inspiration: https://css-tricks.com/ie-10-specific-styles/
var b = document.documentElement;
b.setAttribute('data-useragent',  navigator.userAgent);
b.setAttribute('data-platform', navigator.platform );

// Inspiration: http://jonhall.info/how_to/create_a_playlist_for_html5_audio
jQuery(function ($) {
  $(document).ready(function () {
    var supportsAudio = !! document.createElement('audio').canPlayType;
    var hasPlayer     = $('.audio-player-wrap')[0];

    console.log('supportsAudio', supportsAudio);
    console.log('hasPlayer', hasPlayer);

    if (supportsAudio, hasPlayer) {
        var index     = 0;
        var playing   = false;
        var mediaPath = 'https://gdriv.es/markhillard/Mythium/';
        var extension = '.mp3';
        var npAction  = $('#npAction');
        var npTitle   = $('#npTitle');
        var $audio    = $('#audio1');
        var audioEl   = $audio[0];

        var audioTracks = window.audioTracks || [];
        var tracks = [];

        if (audioTracks && audioTracks[0]) {
          tracks = audioTracks.map(function(track, i) {
            return {
              "track": i,
              "name": track.track_name,
              "file": track.track_file,
              "length": track.track_length || ''
            };
          });
        }

        console.log('tracks', tracks);
        tracks.forEach(function(track) {
          var $clone = $('.plItem-clone').clone();
          var trackNum = track.track + 1
          var prefix    = trackNum > 9 ? '' : '0';

          $clone.find('.plNum').text(prefix + trackNum + '.');
          $clone.find('.plTitle').text(track.name);
          $clone.find('.plLength').text(track.length);

          $('#plList').append($clone);
          $('#plList').find('.plItem-clone').removeClass('plItem-clone');
        });

        var trackCount = tracks.length;


        //Handlers  --------------------------------------------

        $audio.bind('play', audioPlay);
        $audio.bind('pause', audioPause);
        $audio.bind('ended', audioEnded);

        $('#btnPrev').click(function () {
            if ((index - 1) > -1) {
                index--;
                loadTrack(index);
                if (playing) {
                    $audio.play();
                }
            } else {
                $audio.pause();
                index = 0;
                loadTrack(index);
            }
        });

        $('#btnNext').click(function () {
            if ((index + 1) < trackCount) {
                index++;
                loadTrack(index);
                if (playing) {
                    $audio.play();
                }
            } else {
                $audio.pause();
                index = 0;
                loadTrack(index);
            }
        });

        $('#plList li').click(function () {
            var id = parseInt($(this).index());
            if (id !== index) {
                playTrack(id);
            }
        });

        //CONTROL FLOW START --------------------------------------------
        loadTrack(index);


        //Functions -----------------------------------------------------
        function loadTrack(id) {
            var track = tracks[id];

            console.log('loadTrack', id);
            audioEl.src = tracks[id].file;
            $('.plSel').removeClass('plSel');
            $('#plList li:eq(' + id + ')').addClass('plSel');
            npTitle.text(tracks[id].name + ' - Matt Kirkegaard');
            index = id;
        };

        function playTrack(id) {
          console.log('playTrack');
          window.audioTrack = $audio;
            loadTrack(id);
            audioEl.play();
        };

        function audioPlay() {
          playing = true;
          npAction.text('Now Playing...');
        }

        function audioPause() {
          playing = false;
          npAction.text('Paused...');
        }

        function audioEnded() {
          npAction.text('Paused...');
          if ((index + 1) < trackCount) {
              index++;
              loadTrack(index);
              audioEl.play();
          } else {
              audioEl.pause();
              index = 0;
              loadTrack(index);
          }
        }
    }
  });
});

jQuery(function($)
{

});
